import { Modal, Spin } from 'antd';
import { LanguageContext } from 'context/languageContext';
import { TonContext } from 'context/tonContext';
import { useContext } from 'react';
import QRCode from 'react-qr-code';

import styles from './index.module.css';
import { ModalComponentV1 } from '@/Components/ModalComponentV1';
import { CustomButton } from '@/Components/CustomButton';
import { useRouter } from 'next/navigation';
import { PROP_IS_SUPPORT_CHAT } from '@/lib/constants';

type Props = {
  isCardModalOpen: boolean;
  setIsTonModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  QRString: string;
};
const ModalTon = ({ setIsTonModalOpen, isCardModalOpen, QRString }: Props) => {
  const {
    replacementStarted,
    turnBackWalletFunc,
    userTonWallet,
    responseConnectTon,
    clearResponse,
  } = useContext(TonContext);
  const router = useRouter();

  const { t } = useContext(LanguageContext);
  // TransactionTonV2

  const onClose = () => {
    if (replacementStarted) {
      turnBackWalletFunc();
    }
    clearResponse();
    setIsTonModalOpen(false);
  };

  console.log('replacementStarted', replacementStarted);

  return (
    <ModalComponentV1
      title={
        userTonWallet && !replacementStarted
          ? t('SuccessfulConnect')
          : t('connectTon')
      }
      isOpen={isCardModalOpen}
      onClose={onClose}
    >
      <>
        {responseConnectTon.status === '' ? (
          <div>
            <div className={styles.qrWrapper}>
              {QRString ? (
                <QRCode
                  value={QRString || ''}
                  size={256}
                  className={styles.qr}
                />
              ) : (
                <Spin size="large" />
              )}
            </div>

            <img
              className={styles.img}
              src={'/assets/svg/tonkeeper.svg'}
              alt="tonkeeper"
              width="39.41px"
              height="39px"
            />
            <>
              {replacementStarted ? (
                <p className={styles.firstP}>{t('PlsScanQR')}</p>
              ) : (
                <p className={styles.firstP}>{t('plsInstalTon')}</p>
              )}
              <p className={styles.secondP}>{t('payoutBy')}</p>
            </>
          </div>
        ) : null}
        {responseConnectTon.status === 'connected' ? (
          <div className={styles.wrapper}>
            <img
              src="/assets/svg/successIcon.svg"
              alt="success circle"
              width={48}
              height={48}
            />

            <div className={styles.textWrapper}>
              <div>{t('TonKeeperConnected')}</div>
              <div>{t('NowYouCanRecivePayouts')}</div>
            </div>

            <CustomButton
              sizeButton="large"
              typeButton="primary"
              className={styles.btnClose}
              onClick={onClose}
            >
              <span>{t('close')}</span>
            </CustomButton>
          </div>
        ) : responseConnectTon.status === 'failed' ||
          responseConnectTon.status === 'alreadyConnected' ? (
          <div className={styles.wrapper}>
            <img
              src="/assets/svg/erorrIconCircle.svg"
              alt="error icon"
              width={48}
              height={48}
            />

            <div className={styles.textWrapper}>
              <div>{t('TonKeeperNotConnected')}</div>

              {responseConnectTon.status === 'alreadyConnected' ? (
                <div>{t('AlreadyAccount')}</div>
              ) : (
                <div>{t('TryAgainConnect')}</div>
              )}
            </div>

            <div className={styles.btnsWrapper}>
              <CustomButton
                sizeButton="large"
                typeButton="tertiary"
                className={styles.btnClose}
                onClick={() => {
                  router.push(`/messages?${PROP_IS_SUPPORT_CHAT}=true`);
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                  <img
                    src="/assets/svg/support.svg"
                    alt="chat"
                    width={20}
                    height={20}
                  />
                  <span>{t('support')}</span>
                </div>
              </CustomButton>
              <CustomButton
                sizeButton="large"
                typeButton="primary"
                className={styles.btnClose}
                onClick={() => {
                  clearResponse();
                }}
              >
                <span>{t('tryAgain')}</span>
              </CustomButton>
            </div>
          </div>
        ) : null}
      </>
    </ModalComponentV1>
  );
};

export default ModalTon;
